import { useViewport } from '@nuvolo/nuux-theme/hooks/useViewport';
import React from 'react';
import If from '#/common/components/If';
import AssetDataGrid from '../AssetDataGrid';
import AssetList from '../AssetList';
import type { Filter } from '#/common/components/DataGrid';

interface AssetsProps {
  permanentFilters?: Filter[];
}

const Assets: React.FC<AssetsProps> = ({ permanentFilters }) => {
  const { isDesktop } = useViewport();

  return (
    <>
      <If condition={isDesktop}>
        <AssetDataGrid permanentFilters={permanentFilters} />
      </If>
      <If condition={!isDesktop}>
        <AssetList />
      </If>
    </>
  );
};

export default React.memo(Assets);
